const cast = {
    id: "",
    name: "",
    imageUrl: "",
    characters: [{
        name:""
    }]
}

export default cast;